export default function CopyGiftModal({
  lang, darkMode,
  copyGiftModal, setCopyGiftModal,
  copyWishlists, setCopyWishlists,
  copyTargetWishlistId, setCopyTargetWishlistId,
  confirmCopyGift, tr,
}) {
  const close = function() {
    setCopyGiftModal(null);
    setCopyWishlists([]);
    setCopyTargetWishlistId(null);
  };

  return (
    <div className="modal-overlay" onClick={function(e) { if (e.target === e.currentTarget) close(); }}>
      <div className="modal">
        <div style={{ textAlign: "center", marginBottom: 18 }}>
          <div style={{ fontSize: 40, marginBottom: 10 }}>🤩</div>
          <h3 style={{ fontFamily: "Playfair Display, serif", fontSize: 20, marginBottom: 6 }}>
            {lang === "es" ? "Agregar a tu Wishlu" : lang === "fi" ? "Lisää omaan Wishluusi" : "Add to your Wishlu"}
          </h3>
          <p style={{ fontSize: 13, color: "#999", lineHeight: 1.5 }}>
            {lang === "es"
              ? "Este producto se agregará a tu propia lista de deseos para que tus familiares sepan que también lo quieres."
              : lang === "fi"
              ? "Tämä tuote lisätään omaan Wishluusi, jotta perheesi tietää että haluat sen myös."
              : "This item will be added to your own Wishlu so your family knows you want it too."}
          </p>
        </div>

        {copyGiftModal.gift.photoUrl && (
          <div style={{ display: "flex", alignItems: "center", gap: 12, background: "#faf8f5", borderRadius: 12, padding: "12px 14px", marginBottom: 18, border: "1px solid #e8e2d9" }}>
            <img src={copyGiftModal.gift.photoUrl} alt="" style={{ width: 52, height: 52, borderRadius: 8, objectFit: "cover", flexShrink: 0 }} />
            <div>
              <div style={{ fontFamily: "Playfair Display, serif", fontSize: 14, marginBottom: 2 }}>{copyGiftModal.gift.name}</div>
              {copyGiftModal.gift.price && <div style={{ fontSize: 12, color: "#d4a853", fontWeight: 600 }}>{copyGiftModal.gift.price}</div>}
            </div>
          </div>
        )}

        {!copyGiftModal.gift.photoUrl && copyGiftModal.gift.name && (
          <div style={{ background: "#faf8f5", borderRadius: 12, padding: "12px 14px", marginBottom: 18, border: "1px solid #e8e2d9", fontFamily: "Playfair Display, serif", fontSize: 14 }}>
            {copyGiftModal.gift.name}
          </div>
        )}

        {copyWishlists.length > 1 && (
          <div className="campo" style={{ marginBottom: 16 }}>
            <label className="campo-label">
              {lang === "es" ? "Agregar a" : lang === "fi" ? "Lisää" : "Add to"}
            </label>
            <select
              className="campo-input"
              value={copyTargetWishlistId || ""}
              onChange={function(e) { setCopyTargetWishlistId(e.target.value); }}
              style={{ padding: "10px 14px" }}
            >
              {copyWishlists.map(function(wl) {
                return (
                  <option key={wl.id} value={wl.id}>
                    🎁 {wl.name} ({(wl.gifts || []).length} {tr("gifts")})
                  </option>
                );
              })}
            </select>
          </div>
        )}

        <div style={{ display: "flex", gap: 8 }}>
          <button className="btn btn-dorado" style={{ flex: 2 }} onClick={confirmCopyGift}>
            {lang === "es" ? "¡Sí, lo quiero! 🤩" : lang === "fi" ? "Kyllä, haluan sen! 🤩" : "Yes, I want this! 🤩"}
          </button>
          <button className="btn btn-gris" onClick={close}>
            {tr("cancel")}
          </button>
        </div>
      </div>
    </div>
  );
}
